import { DOMAIN, urlParam } from "../config";
import { t } from "../i18n";
import { countrySelect } from "./country-select";
import { restrictPhoneCountries } from "./phone-input";
import { handlesModalType, goToSuccessPage } from "../success-page";

const PREVIEW_CODE = "QuhYdcje8Tq6";

// The login button is injected by this script, not written into the page,
// so no landing carries a rule for it. One class selector only, so a landing
// that wants its own look can still override it.
function styleLoginButton() {
	if (document.getElementById("sdk-login-button-style")) {
		return;
	}

	const style = document.createElement("style");
	style.id = "sdk-login-button-style";
	style.textContent =
		".sdk-login-button {" +
		"display: block;" +
		"box-sizing: border-box;" +
		"max-width: 420px;" +
		"margin: 24px auto;" +
		"padding: 16px 28px;" +
		"border-radius: 10px;" +
		"background: #16884a;" +
		"color: #fff;" +
		"font-size: 17px;" +
		"font-weight: 600;" +
		"line-height: 1.3;" +
		"text-align: center;" +
		"text-decoration: none;" +
		"cursor: pointer;" +
		"}" +
		".sdk-login-button:hover," +
		".sdk-login-button:focus {" +
		"background: #12703c;" +
		"color: #fff;" +
		"text-decoration: none;" +
		"}";

	document.head.appendChild(style);
}

function replaceFormsWithLoginButton(url) {
	styleLoginButton();
	document.querySelectorAll(".sdk-form").forEach((form) => {
		const link = document.createElement("a");
		link.href = url;
		link.className = "sdk-login-button";
		link.textContent = t("login_button_text");
		form.replaceWith(link);
	});
}

function prefillFromParams() {
	let firstName = urlParam("firstName");
	let lastName = urlParam("lastName");
	let fullName = urlParam("fullName");

	if (fullName !== "") {
		let separator = "+";
		if (fullName.substr(0, fullName.indexOf(separator)) === "") {
			separator = " ";
		}
		firstName = fullName.substr(0, fullName.indexOf(separator));
		lastName = fullName.substr(fullName.indexOf(separator) + 1);
		fullName = firstName + " " + lastName;
	}

	const fill = (name, value) => {
		document
			.querySelectorAll('.sdk-form input[name="' + name + '"]')
			.forEach((input) => {
				input.value = value;
			});
	};

	fill("fullName", fullName);
	fill("firstName", firstName);
	fill("lastName", lastName);
	fill("email", urlParam("email"));
}

//A hung request is dropped after 8s, and an unclear answer means "let the
//visitor order" - the CRM's duplicate check catches the rare double.
function checkTransactionUsed(transactionId) {
	const controller = new AbortController();
	const timer = setTimeout(() => controller.abort(), 8000);

	return fetch(DOMAIN + "/funnels-sdk/check-transaction-id/" + transactionId, {
		method: "POST",
		signal: controller.signal,
	})
		.then((response) => response.json())
		.then((data) => {
			clearTimeout(timer);
			if (data && data.success) {
				//A transaction that already went through: the payment funnels
				//offer the link again, the COD ones send the customer to the
				//page their order ended on rather than a form that would
				//duplicate it. With no page configured, the form stays - the
				//CRM's duplicate check is the backstop, as everywhere else.
				if (window.MODAL_TYPE === "codRedirect") {
					goToSuccessPage(data.redirect_url);
					return;
				}
				replaceFormsWithLoginButton(data.success);
			} else if (data) {
				countrySelect(data.allowed_countries);
				restrictPhoneCountries(data.allowed_countries);
			}
		})
		.catch(() => {
			clearTimeout(timer);
		});
}

export function entryFlow() {
	//The transaction gate protects checkout pages. Entry pages - index,
	//packs, advertorials - carry no form and must stay reachable without a
	//transaction (ad reviewers, direct visits).
	if (!document.querySelector(".sdk-form")) {
		return;
	}

	//An outcome this library does not implement stays with the legacy bundle.
	if (!handlesModalType()) {
		return;
	}

	const transactionId = urlParam("transaction_id");
	const preview = urlParam("preview_code") === PREVIEW_CODE;

	if (!transactionId && !preview) {
		window.location.href = "/404.html";
		return;
	}

	prefillFromParams();

	if (preview) {
		return;
	}

	checkTransactionUsed(transactionId);
}
